"use client";
import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { memo as c, forwardRef as p } from "react";
import { useSvgIcon as V } from "../useSvgIcon.js";
const L = c(
  p((i, t) => {
    const { monochrome: o, ...a } = i, r = V({
      ...a,
      ref: t
    });
    return /* @__PURE__ */ l(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r(),
        children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M18.6602 10.3115C19.0347 10.1183 19.4799 10.1182 19.8545 10.3115C19.8992 10.3348 19.9426 10.3605 19.9844 10.3887L29.6865 16.1318L29.6982 16.1387H29.7021C29.8886 16.2532 30.0015 16.457 30 16.6758C30.0022 16.9001 29.8841 17.1087 29.6904 17.2217L19.9873 22.9648C19.9454 22.9929 19.902 23.0186 19.8574 23.042C19.4828 23.2353 19.0377 23.2353 18.6631 23.042C18.6184 23.0186 18.5752 22.9928 18.5332 22.9648L11.9082 19.043C12.1798 18.7691 12.409 18.4532 12.5791 18.1025C12.9092 17.4122 13.0731 16.6537 13.0576 15.8887C13.0709 15.194 12.9263 14.5064 12.6387 13.875L18.5303 10.3887C18.572 10.3605 18.6154 10.3348 18.6602 10.3115ZM11.2207 14.7148C11.351 15.1336 11.4158 15.5707 11.4111 16.0098C11.4173 16.4809 11.337 16.9494 11.1738 17.3916C11.0506 17.7258 10.8449 18.0216 10.5801 18.2568L8.83105 17.2217C8.74224 17.1698 8.66663 17.0971 8.6123 17.0098C8.42796 16.7134 8.51911 16.3231 8.81543 16.1387L8.82715 16.1318L11.2207 14.7148Z",
              fill: o ? "#808080" : "#0A2767"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M16.3271 18.6758H12.2275C12.3617 18.4968 12.4805 18.3057 12.5791 18.1025C12.9093 17.4121 13.0731 16.6538 13.0576 15.8887C13.0716 15.1565 12.9124 14.4313 12.5928 13.7725C12.4217 13.4239 12.1926 13.1097 11.9189 12.8398H16.3271V18.6758ZM9.95996 13.3047C10.1396 13.3701 10.3104 13.4604 10.4658 13.5762C10.8013 13.8434 11.0521 14.2025 11.1875 14.6094C11.3407 15.0598 11.4172 15.533 11.4121 16.0088C11.4183 16.4802 11.3371 16.9492 11.1738 17.3916C11.0278 17.7876 10.7685 18.1325 10.4287 18.3828C10.2825 18.4841 10.1248 18.5651 9.95996 18.626V13.3047ZM27.5186 3C28.1859 3.01614 28.7145 3.5699 28.6992 4.2373V6.90723L19.583 9.51172L9.81543 6.90723V4.2373C9.80014 3.5698 10.3286 3.01599 10.9961 3H27.5186Z",
              fill: o ? "var(--icon-color)" : "#0364B8"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M16.3262 12.7666H11.8438C11.6677 12.6033 11.4748 12.4572 11.2666 12.333C10.8187 12.0738 10.3243 11.9096 9.81445 11.8467V6.90625H16.3262V12.7666Z",
              fill: o ? "var(--icon-color)" : "#0078D4"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M22.8378 6.90625H16.3262V12.7667L22.8378 18.6272H28.6983V12.7667L22.8378 6.90625Z",
              fill: o ? "var(--icon-color)" : "#28A8EA"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M16.3262 12.7676H22.8378V18.628H16.3262V12.7676Z",
              fill: o ? "var(--icon-color)" : "#0078D4"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M16.3262 18.6289H22.8378V24.4894H16.3262V18.6289Z",
              fill: o ? "var(--icon-color)" : "#0364B8"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M16.3262 23.9814H9.95898V20.0527C10.3975 19.9706 10.8217 19.8159 11.2119 19.5918C11.6092 19.3552 11.9519 19.0423 12.2266 18.6758H16.3262V23.9814Z",
              fill: o ? "var(--icon-color)" : "#14447D"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M22.8379 18.6289H28.6984V24.4894H22.8379V18.6289Z",
              fill: o ? "var(--icon-color)" : "#0078D4"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M30 27.7207C29.9983 28.1353 29.801 28.5248 29.4678 28.7715C29.4678 28.7715 29.3922 28.8258 29.3486 28.8506C29.2903 28.8869 29.2293 28.9186 29.166 28.9453C29.0193 28.9984 28.8657 29.0311 28.71 29.041C28.6984 29.0411 28.6887 29.0458 28.6777 29.0459H9.85547C9.11848 29.0506 8.51673 28.4567 8.51172 27.7197V20.084C8.71646 20.1117 8.92369 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.5809 19.3721 11.9036 19.0869 12.168 18.7539L18.6709 22.4648C18.7128 22.4922 18.756 22.5176 18.8008 22.54L19.3311 22.8506C19.5132 22.8431 19.6918 22.798 19.8564 22.7197C19.9013 22.6975 19.945 22.6726 19.9873 22.6465L29.6895 17.1904L29.7021 17.1836C29.8861 17.0798 29.9998 16.885 30 16.6738V27.7207ZM8.83301 16.8535H8.83789L10.833 17.9912C10.716 18.1376 10.5812 18.2705 10.4287 18.3828C10.0544 18.6423 9.60557 18.7728 9.15039 18.7549C8.93291 18.7604 8.71709 18.73 8.51172 18.667V16.6738L8.83301 16.8535Z",
              fill: o ? "var(--icon-color)" : "url(#paint0_linear_13157_80306)"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.5",
              d: "M29.4795 16.6309V17.3076L19.335 24.293L11.9131 19.0391C12.1543 18.795 12.3587 18.5166 12.5205 18.2109C15.3785 19.8415 19.0452 21.9344 19.0869 21.957L19.4648 22.1787C19.4973 22.1656 19.5303 22.1526 19.5693 22.1396C19.5889 22.1267 29.335 16.6432 29.3691 16.624L29.4795 16.6309ZM9.09863 16.2588L9.11816 16.2656L9.18945 16.3115C9.18945 16.3115 9.99987 16.7728 11.1562 17.4326C11.0483 17.7079 10.8857 17.9567 10.6787 18.165L8.83203 16.8584C8.83203 16.8548 8.82872 16.8516 8.8252 16.8516L7.86133 16.2725V15.7842L8.25879 15.7773L9.09863 16.2588Z",
              fill: o ? "black" : "#0A2767"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M30 27.7207C29.995 28.4574 29.394 29.0506 28.6572 29.0459H9.85449C9.11764 29.0506 8.51638 28.4566 8.51172 27.7197V20.084C8.71646 20.1117 8.92369 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.5003 19.4201 11.76 19.2078 11.9863 18.9648L18.5322 22.6475C18.5743 22.674 18.6185 22.6986 18.6631 22.7207C19.0397 22.9045 19.4799 22.9045 19.8564 22.7207C19.9014 22.6986 19.9449 22.6735 19.9873 22.6475L29.6895 17.1904L29.7021 17.1836C29.886 17.0798 29.9998 16.885 30 16.6738V27.7207ZM8.51172 16.6738C8.51366 16.8869 8.6311 17.082 8.81836 17.1836L8.83008 17.1904L10.6367 18.2061C10.5711 18.2686 10.5023 18.3286 10.4287 18.3828C10.0544 18.6423 9.60557 18.7728 9.15039 18.7549C8.93291 18.7604 8.71709 18.73 8.51172 18.667V16.6738Z",
              fill: o ? "var(--icon-color)" : "#1490DF"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.1",
              d: "M20.1291 22.5684L19.9839 22.6498C19.9418 22.6765 19.8983 22.7011 19.8536 22.7233C19.6937 22.8019 19.5197 22.8479 19.3418 22.8588L23.0333 27.2242L29.4726 28.7759C29.6491 28.6426 29.7894 28.4673 29.8809 28.266L20.1291 22.5684Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.05",
              d: "M20.7867 22.1973L19.9839 22.6485C19.9418 22.6753 19.8983 22.6999 19.8536 22.7221C19.6937 22.8006 19.5197 22.8467 19.3418 22.8575L21.0713 27.626L29.4746 28.7727C29.8056 28.5241 30.0005 28.1344 30.0007 27.7204V27.5778L20.7867 22.1973Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M18.6699 22.4668C18.7118 22.4942 18.7551 22.5195 18.7998 22.542L29.46 28.7852C29.2268 28.9559 28.9443 29.0474 28.6553 29.0459H9.87305C9.12076 29.0452 8.51108 28.4348 8.51172 27.6826V20.084C8.71646 20.1117 8.92369 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.5805 19.3723 11.9028 19.0874 12.167 18.7549L18.6699 22.4668ZM8.83301 16.8545H8.83691L10.832 17.9932C10.7153 18.1389 10.5806 18.2709 10.4287 18.3828C10.0544 18.6423 9.60557 18.7728 9.15039 18.7549C8.93291 18.7604 8.71709 18.73 8.51172 18.667V16.6738L8.83301 16.8545Z",
              fill: o ? "var(--icon-color)" : "#28A8EA"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.1",
              d: "M16.4365 8.20898C17.0942 8.21154 17.6264 8.74464 17.6279 9.40234V23.292C17.6267 23.7789 17.3305 24.2161 16.8789 24.3984C16.7391 24.4586 16.5887 24.4902 16.4365 24.4902H8.51172V20.084C8.71646 20.1117 8.92369 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.8034 19.2396 12.2786 18.7217 12.5791 18.1025C12.9093 17.4121 13.0731 16.6538 13.0576 15.8887C13.0716 15.1566 12.9124 14.4313 12.5928 13.7725C12.2993 13.1746 11.8386 12.6742 11.2666 12.333C10.6582 11.9809 9.96445 11.8032 9.26172 11.8184C9.00983 11.8111 8.75866 11.8279 8.51172 11.8662V8.86035H9.81445V8.20898H16.4365ZM9.19824 13.1855C9.65312 13.1663 10.1008 13.3042 10.4658 13.5762C10.8013 13.8434 11.0521 14.2025 11.1875 14.6094C11.3407 15.0598 11.4162 15.533 11.4111 16.0088C11.4173 16.4802 11.3371 16.9492 11.1738 17.3916C11.0278 17.7876 10.7686 18.1324 10.4287 18.3828C10.0544 18.6423 9.60557 18.7728 9.15039 18.7549C8.93291 18.7604 8.71709 18.73 8.51172 18.667V13.2852C8.73208 13.2143 8.96398 13.1795 9.19824 13.1855Z",
              fill: o ? "" : "black"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.2",
              d: "M15.7852 8.86133C15.9739 8.85944 16.16 8.90668 16.3252 8.99805C16.7243 9.19909 16.9763 9.60783 16.9766 10.0547V23.9443C16.9783 24.1016 16.9449 24.2575 16.8789 24.4004C16.698 24.8459 16.2661 25.1384 15.7852 25.1406H8.51172V20.084C8.71647 20.1117 8.92368 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.8034 19.2396 12.2787 18.7217 12.5791 18.1025C12.9093 17.4121 13.0731 16.6538 13.0576 15.8887C13.0716 15.1566 12.9124 14.4313 12.5928 13.7725C12.2993 13.1746 11.8386 12.6742 11.2666 12.333C10.6582 11.9809 9.96444 11.8032 9.26172 11.8184C9.00983 11.8111 8.75866 11.8279 8.51172 11.8662V8.86133H15.7852ZM9.19824 13.1855C9.65311 13.1663 10.1008 13.3042 10.4658 13.5762C10.8013 13.8434 11.0521 14.2025 11.1875 14.6094C11.3407 15.0598 11.4162 15.533 11.4111 16.0088C11.4173 16.4802 11.3371 16.9492 11.1738 17.3916C11.0278 17.7877 10.7686 18.1324 10.4287 18.3828C10.0544 18.6423 9.60558 18.7728 9.15039 18.7549C8.93291 18.7604 8.7171 18.73 8.51172 18.667V13.2852C8.73208 13.2143 8.96398 13.1795 9.19824 13.1855Z",
              fill: o ? "" : "black"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.2",
              d: "M15.7852 8.86133C15.9739 8.85944 16.16 8.90668 16.3252 8.99805C16.7243 9.19909 16.9763 9.60783 16.9766 10.0547V22.6416C16.9734 23.2992 16.4427 23.8322 15.7852 23.8379H8.51172V20.084C8.71647 20.1117 8.92368 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.8034 19.2396 12.2787 18.7217 12.5791 18.1025C12.9093 17.4121 13.0731 16.6538 13.0576 15.8887C13.0716 15.1566 12.9124 14.4313 12.5928 13.7725C12.2993 13.1746 11.8386 12.6742 11.2666 12.333C10.6582 11.9809 9.96444 11.8032 9.26172 11.8184C9.00983 11.8111 8.75866 11.8279 8.51172 11.8662V8.86133H15.7852ZM9.19824 13.1855C9.65311 13.1663 10.1008 13.3042 10.4658 13.5762C10.8013 13.8434 11.0521 14.2025 11.1875 14.6094C11.3407 15.0598 11.4162 15.533 11.4111 16.0088C11.4173 16.4802 11.3371 16.9492 11.1738 17.3916C11.0278 17.7877 10.7686 18.1324 10.4287 18.3828C10.0544 18.6423 9.60558 18.7728 9.15039 18.7549C8.93291 18.7604 8.7171 18.73 8.51172 18.667V13.2852C8.73208 13.2143 8.96398 13.1795 9.19824 13.1855Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              opacity: "0.2",
              d: "M15.1338 8.86133C15.7922 8.86168 16.3255 9.39626 16.3252 10.0547V22.6416C16.3245 23.3001 15.7924 23.8347 15.1338 23.8379H8.51172V20.084C8.71646 20.1117 8.92369 20.1251 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.8034 19.2396 12.2786 18.7217 12.5791 18.1025C12.9093 17.4121 13.0731 16.6538 13.0576 15.8887C13.0716 15.1566 12.9124 14.4313 12.5928 13.7725C12.2993 13.1746 11.8386 12.6742 11.2666 12.333C10.6582 11.9809 9.96445 11.8032 9.26172 11.8184C9.00983 11.8111 8.75866 11.8279 8.51172 11.8662V8.86133H15.1338ZM9.19824 13.1855C9.65312 13.1663 10.1008 13.3042 10.4658 13.5762C10.8013 13.8434 11.0521 14.2025 11.1875 14.6094C11.3407 15.0598 11.4162 15.533 11.4111 16.0088C11.4173 16.4802 11.3371 16.9492 11.1738 17.3916C11.0278 17.7876 10.7686 18.1324 10.4287 18.3828C10.0544 18.6423 9.60557 18.7728 9.15039 18.7549C8.93291 18.7604 8.71709 18.73 8.51172 18.667V13.2852C8.73208 13.2143 8.96398 13.1795 9.19824 13.1855Z",
              fill: o ? "" : "black"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M15.1318 8.86133C15.791 8.86133 16.3251 9.3956 16.3252 10.0547V21.9932C16.3252 22.6524 15.791 23.1865 15.1318 23.1865H3.19336C2.53426 23.1864 2 22.6523 2 21.9932V10.0547C2.00011 9.39568 2.53434 8.86145 3.19336 8.86133H15.1318ZM9.26172 11.8184C8.50335 11.7966 7.75313 11.9843 7.09473 12.3613C6.50031 12.7161 6.0256 13.2406 5.73145 13.8672C5.41336 14.5562 5.25515 15.3087 5.26855 16.0674C5.25601 16.7917 5.4168 17.5089 5.73828 18.1582C6.0386 18.7576 6.50518 19.2581 7.08203 19.5996C7.70451 19.9576 8.41395 20.1374 9.13184 20.1201C9.86034 20.1372 10.58 19.9547 11.2119 19.5918C11.8034 19.2396 12.2786 18.7217 12.5791 18.1025C12.9093 17.4121 13.0731 16.6538 13.0576 15.8887C13.0716 15.1566 12.9124 14.4313 12.5928 13.7725C12.2993 13.1746 11.8386 12.6742 11.2666 12.333C10.6582 11.9809 9.96445 11.8032 9.26172 11.8184ZM9.19824 13.1855C9.65312 13.1663 10.1008 13.3042 10.4658 13.5762C10.8013 13.8434 11.0521 14.2025 11.1875 14.6094C11.3407 15.0598 11.4162 15.533 11.4111 16.0088C11.4173 16.4802 11.3371 16.9492 11.1738 17.3916C11.0278 17.7876 10.7686 18.1324 10.4287 18.3828C10.0544 18.6423 9.60557 18.7728 9.15039 18.7549C8.72291 18.7657 8.30271 18.6394 7.95215 18.3945C7.60795 18.1434 7.34142 17.7996 7.18457 17.4033L7.18555 17.4043C6.83332 16.4848 6.83482 15.467 7.19043 14.5488C7.35069 14.1484 7.62183 13.802 7.97168 13.5498C8.33164 13.302 8.76133 13.1742 9.19824 13.1855Z",
              fill: o ? "var(--icon-color)" : "url(#paint1_linear_13157_80306)"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M22.8379 6.90625H28.6984V12.7667H22.8379V6.90625Z",
              fill: o ? "var(--icon-color)" : "#50D9FF"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M5.73132 13.8673C6.0255 13.2406 6.50033 12.716 7.09487 12.3612C7.75327 11.9842 8.50292 11.7963 9.26129 11.8181C9.96416 11.8029 10.6577 11.981 11.2662 12.3332C11.8383 12.6744 12.2991 13.1743 12.5926 13.7722C12.9123 14.4311 13.0716 15.1563 13.0576 15.8885C13.0731 16.6537 12.9092 17.412 12.579 18.1025C12.2785 18.7218 11.8031 19.2395 11.2115 19.5917C10.5796 19.9546 9.86025 20.1375 9.13171 20.1204C8.41382 20.1377 7.70497 19.9575 7.08249 19.5995C6.50543 19.2579 6.03887 18.7574 5.7385 18.1578C5.41695 17.5084 5.25574 16.7914 5.26836 16.0669C5.25496 15.3082 5.41323 14.5563 5.73132 13.8673ZM7.18472 17.4031C7.34156 17.7994 7.60754 18.143 7.95178 18.3942C8.30242 18.6393 8.72228 18.7657 9.14992 18.7549C9.60534 18.7729 10.0543 18.6422 10.4288 18.3825C10.7687 18.1321 11.0277 17.7875 11.1737 17.3914C11.337 16.949 11.4176 16.4804 11.4114 16.009C11.4165 15.533 11.3407 15.0596 11.1874 14.609C11.052 14.2021 10.8014 13.8434 10.4659 13.5762C10.1008 13.3042 9.65305 13.1662 9.1981 13.1855C8.76119 13.1742 8.33193 13.3017 7.97197 13.5495C7.6219 13.8018 7.35088 14.1485 7.19058 14.5491C6.83497 15.4673 6.83312 16.4849 7.18536 17.4044L7.18472 17.4031Z",
              fill: o ? "" : "white"
            }
          ),
          /* @__PURE__ */ l("defs", { children: [
            /* @__PURE__ */ l(
              "linearGradient",
              {
                id: "paint0_linear_13157_80306",
                x1: "19.2559",
                y1: "16.6738",
                x2: "19.2559",
                y2: "29.0459",
                gradientUnits: "userSpaceOnUse",
                children: [
                  /* @__PURE__ */ C("stop", { stopColor: "#35B8F1" }),
                  /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#28A8EA" })
                ]
              }
            ),
            /* @__PURE__ */ l(
              "linearGradient",
              {
                id: "paint1_linear_13157_80306",
                x1: "4.48864",
                y1: "7.92869",
                x2: "13.8369",
                y2: "24.1195",
                gradientUnits: "userSpaceOnUse",
                children: [
                  /* @__PURE__ */ C("stop", { stopColor: "#1784D9" }),
                  /* @__PURE__ */ C("stop", { offset: "0.5", stopColor: "#107AD5" }),
                  /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#0A63C9" })
                ]
              }
            )
          ] })
        ]
      }
    );
  })
);
L.displayName = "IconOutlook";
export {
  L as IconOutlook
};
